import React from "react";

import {
    BrowserRouter as Router,
} from "react-router-dom";
import Header from "./components/Header/Header.js"
import Form from "./components/Form/Form_veryOld.js"
import Table from "./components/Table/Table.js"
import { useState } from 'react'


function App() {
    const [state, setState] = useState({})
    return (
        <div>
            <Router>
                <div>
                    <Header ></Header>
                    <Form setState={setState} state={state} />
                </div>
                <div>
                    {state.name && <Table setState={setState} state={state}/>}
                </div>
            </Router>
        </div>
    )
}

export default App;

